export function base64ToArrayBuffer(base64) {
	const binaryString = atob(base64);
	const bytes = new Uint8Array(binaryString.length);

	for (let i = 0; i < binaryString.length; i++) {
		bytes[i] = binaryString.charCodeAt(i);
	}

	return bytes.buffer;
}

export function openBase64Pdf(base64Content, name = 'Dokument.pdf') {
	if (!base64Content) {
		return;
	}

	const cleanBase64 = base64Content.includes(',') ? base64Content.split(',')[1] : base64Content;

	const blob = new Blob([base64ToArrayBuffer(cleanBase64)], {
		type: 'application/pdf',
	});

	const resolvingUrl = URL.createObjectURL(blob);

	const viewerUrl = `/blobviewer?blobUrl=${encodeURIComponent(resolvingUrl)}` + `&title=${encodeURIComponent(name)}`;

	window.open(viewerUrl, '_blank');
	
	setTimeout(() => {
		URL.revokeObjectURL(resolvingUrl);
	}, 60000);
}
